import { lazy, Suspense, useMemo, useEffect } from 'react';
import { useRoutes, Navigate } from 'react-router';
import { useCheckAppStatus } from 'src/hooks/dataHooks/useCheckAppStatus.js';
import { useCheckCampaignStatus } from 'src/hooks/dataHooks/useCheckCampaignStatus';
import useSharedData from 'src/hooks/useSharedData.ts';
import RouterCC from 'src/routes/cc-routes';
import RouterOnline from 'src/routes/online-routes';
//* Hooks
const StaticPageLayout = lazy(() => import('src/layouts/StaticPageLayout.jsx'));
const LoadingScreen = lazy(() => import('src/components/LoadingScreen.jsx'));
const MaintenanceInfo = lazy(() => import('src/pages/maintenance/MaintenanceInfo.jsx'));

//* ----------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen isOnline={false} />}>
      <Component {...props} />
    </Suspense>
  );
};
const MaintenanceInfoPage = Loadable(MaintenanceInfo);

const MAINTENANCE_ROUTES = [
  {
    path: '/',
    element: <StaticPageLayout />,
    children: [{ element: <MaintenanceInfoPage />, index: true }],
  },
  { path: '*', element: <Navigate to="/" replace /> },
];

//* ----------------------------------------------------------------

export default function AppRouter({ isOnline }) {
  const { data } = useCheckAppStatus();
  const isMaintenance = data?.appStatus === 'Maintenance';

  const { data: campData } = useCheckCampaignStatus();
  const { handleEventChange } = useSharedData();

  useEffect(() => {
    let newCampaign = {};

    if (campData || campData?.startDate) {
      newCampaign = campData;
    }
    handleEventChange({ name: 'campaignData', value: newCampaign });
    //* Determine which functional routes to use
  }, [campData]);

  const activeRouteConfig = useMemo(() => {
    // handleEventChange({ name: 'campaignData', value: newCampaign });
    //* Determine which functional routes to use
    return isOnline ? RouterOnline() : RouterCC();
  }, [isOnline]);

  //* Return the correct route.
  return useRoutes(isMaintenance ? MAINTENANCE_ROUTES : activeRouteConfig);
}
